import React, { useState, useEffect } from "react";
import "./Navigation.css";
// import { BrowserRouter as Router, Route, Link, Switch } from 'react-router-dom';
import { Link } from 'react-scroll';
import AOS from 'aos';

const Navigation = () => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);  // state to track scroll position

    useEffect(() => {
        AOS.init({
            duration: 1000,  // Duration of the animation
            easing: 'ease-in-out',  // Easing function for the animation
            once: true,  // Animation should only run once
        });

        // Scroll event listener
        const handleScroll = () => {
            if (window.scrollY > 50) {
                setIsScrolled(true);  // Set background color when scrolled
            } else {
                setIsScrolled(false);  // Reset background color when at the top
            }
        };

        // Add event listener
        window.addEventListener('scroll', handleScroll);

        // Cleanup event listener on component unmount
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const toggleMenu = () => {
        //setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    return (
        <header className={`header header-fixed ${isScrolled ? "scrolled" : ""}`}>
            <div data-aos="fade-right" className="logo">
                {/* <a href="#">MyLogo</a> */}
            </div>
            <nav data-aos="fade-left" className={`nav-links ${isMobileMenuOpen ? "active" : ""}`}>
                <ul>
                    <li style={{cursor:'pointer',fontFamily:'cursive'}}><Link to="home" smooth={true} duration={500} style={isScrolled ? { color: 'black',fontWeight:'500' } : { color: 'White',fontWeight:'500' }}>Home</Link></li>
                    <li style={{cursor:'pointer',fontFamily:'cursive'}}><Link to="stay" smooth={true} duration={500} style={isScrolled ? { color: 'black',fontWeight:'500' } : { color: 'White',fontWeight:'500' }}>Stay</Link></li>
                    <li style={{cursor:'pointer',fontFamily:'cursive'}}><Link to="gallery" smooth={true} duration={500} style={isScrolled ? { color: 'black',fontWeight:'500' } : { color: 'White',fontWeight:'500' }}>Gallery</Link></li>
                    <li style={{cursor:'pointer',fontFamily:'cursive'}}><Link to="facilities" smooth={true} duration={500} style={isScrolled ? { color: 'black',fontWeight:'500' } : { color: 'White',fontWeight:'500' }}>Facilities</Link></li>
                    {/* <li><Link to="/services" style={isScrolled ? { color: 'black' } : { color: 'White' }}>Dining</Link></li>
                    <li><Link to="/contact" style={isScrolled ? { color: 'black' } : { color: 'White' }}>Gallery</Link></li>
                    <li><Link to="/contact" style={isScrolled ? { color: 'black' } : { color: 'White' }}>Facilities</Link></li>
                    <li><Link to="/contact" style={isScrolled ? { color: 'black' } : { color: 'White' }}>Contact Us</Link></li> */}
                </ul>
            </nav>
            <div className="mobile-menu-icon" onClick={toggleMenu}>
                <span className="bar"></span>
                <span className="bar"></span>
                <span className="bar"></span>
            </div>
        </header>
    );
};

export default Navigation;
